import {
  Box,
  Drawer,
  DrawerProps,
  Divider,
  Theme,
  makeStyles,
  createStyles,
  Typography,
  SvgIcon,
} from "@material-ui/core";

import { Logo } from "~components/Icons";
import { LinksType, Menu } from "~components/Menu";

import { Footer } from "./Footer";

const drawerMaxWidth = 344;
const drawerMinWidth = 280;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    drawer: {
      width: "20%",
      minWidth: drawerMinWidth,
      maxWidth: drawerMaxWidth,
    },
    drawerPaper: {
      display: "flex",
      flexDirection: "column",
      width: "20%",
      minWidth: drawerMinWidth,
      maxWidth: drawerMaxWidth,

      backgroundColor: theme.palette.dark.main,
      boxShadow: "0 18px 18px 0 rgba(32, 37, 43, 0.06), 0 0 1px 0 rgba(32, 37, 43, 0.05)",
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",

      padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
      paddingRight: theme.spacing(2),

      color: "white",
    },
    mainContent: {
      padding: `${theme.spacing(3)}px ${theme.spacing(2)}px`,
    },
    divider: {
      backgroundColor: "#3f4248",
    },
    tagLine: {
      padding: `${theme.spacing(1)}px ${theme.spacing(1)}px`,

      fontSize: theme.spacing(1.5),
      fontWeight: "bold",
      lineHeight: "16px",
      letterSpacing: 2,
      textTransform: "uppercase",
      color: "white",

      boxShadow: "0 0 0 1px #31363B",
      backgroundColor: "rgba(247, 247, 247, 0.05)",
      borderRadius: 2,
    },
  }),
);

type SidebarProps = {
  isLoading: boolean;
  runsInProduction: boolean;
  onEnvironmentChange: () => void;
  tooltipText: string;
  links: LinksType;
  currentPage: string;
} & DrawerProps;

export const Sidebar = ({
  links,
  tooltipText,
  onEnvironmentChange,
  isLoading = false,
  runsInProduction = false,
  currentPage = "/",
  ...props
}: SidebarProps) => {
  const classes = useStyles();

  return (
    <Drawer
      variant="permanent"
      anchor="left"
      className={classes.drawer}
      classes={{
        paper: classes.drawerPaper,
      }}
      {...props}
    >
      <Box className={classes.header}>
        <SvgIcon component={Logo} style={{ fontSize: 80 }} viewBox="0 0 80 80" />
        <Typography className={classes.tagLine}>for merchants</Typography>
      </Box>

      <Divider className={classes.divider} />

      <Box flex={1} className={classes.mainContent}>
        <Menu isLoading={isLoading} links={links} activePath={currentPage} />
      </Box>

      <Divider className={classes.divider} />

      <Footer
        isLoading={isLoading}
        isProduction={runsInProduction}
        onChange={onEnvironmentChange}
        tooltipText={tooltipText}
      />
    </Drawer>
  );
};
